import { FC, useMemo } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/coaching/advisorLandingPage/ReviewsSection/ReviewsSection.styl'
import { CardBlock } from 'components/features/pfm/Blocks/Blocks'
import { StarsRow } from 'components/features/coaching/advisorPublicPage/StarsRow/StarsRow'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { topReviewGuards } from 'components/features/coaching/advisorStore/guards/advisorsLandingGuards'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { topReviewsSelector } from 'components/features/coaching/advisorStore/selectors/landingPage'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { AdvisorReview } from 'components/features/coaching/advisor/AdvisorReview/AdvisorReview'

const HERO_REVIEW = {
  text: '“Super knowledgeable and reassuring and was able to address all of my questions with real clarity!”',
  name: 'Jennifer G',
  city: 'New York City',
  rating: 5,
  date: 'March 1, 2021',
}


const ReviewsSection: FC = () => {
  const isLoaded = useSimpleGuard(topReviewGuards, {}, 'debug')
  const reviews = useStoreSelector(topReviewsSelector)

  const reviewsChild = useMemo(() => {
    if (!reviews) {
      return null
    }

    return reviews.map((review) => (
      <CardBlock
        key={ review.uid }
        className={ styles.review }
        shadowTheme='medium'
        forceRoundedCorners
        withPadding
      >
        <AdvisorReview review={ review } />
      </CardBlock>
    ))
  }, [reviews])

  return (
    <section className={ cn(styles.reviewsSection) }>
      <div className={ styles.content }>
        { !isLoaded && (
          <LoadingOverlay />
        )}
        <h2 className={ styles.header }>
          WHAT OUR MEMBERS ARE SAYING
        </h2>
        <article className={ styles.heroReview }>
          <p>{ HERO_REVIEW.text }</p>
          <h5>{ HERO_REVIEW.name } from { HERO_REVIEW.city }</h5>
          <StarsRow rating={ HERO_REVIEW.rating } />
        </article>
        { reviewsChild && (
          <div className={ styles.reviews }>
            { reviewsChild }
          </div>
        )}
      </div>
    </section>
  )
}

export default ReviewsSection
